/* eslint-disable react/prop-types */
import { Edit, Add, ExpandMore } from '@mui/icons-material';
import { Box, Button, Grid, Typography, Divider, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { IConstructiveProject } from '../../services/api/constructive-project/ConstructiveProjectServices';
import { IConstructiveSteps } from '../../services/api/constructive-project/ConstructiveStepsServices';

interface ICharacteristicsProject {
  dataProject?: IConstructiveProject;
  dataSteps: IConstructiveSteps[];
  handleEdit: () => void;
  handleNew: () => void;
  permissions: string;
}

export const CharacteristicsProject: React.FC<ICharacteristicsProject> = ({
  dataProject,
  dataSteps,
  handleEdit,
  handleNew,
  permissions
}) => {
  return (
    <Box width='100%'>
      <Box>
        <Box width='100%' paddingY={1}>
          {permissions.includes('add') || permissions.includes('edit') ?
            <Button variant='contained' onClick={dataProject != undefined ? handleEdit : handleNew} sx={{ borderRadius: '25px' }} startIcon={dataProject != undefined ? <Edit /> : <Add />}>{dataProject != undefined ? 'Editar Características' : 'Cadastrar Projeto'}</Button> : null
          }
        </Box>
        {dataProject?.uuid ? (
          <>
            <Grid container display='flex'>
              <Grid container item marginY={1}>
                <Grid item xs={6}>
                  <Typography variant='subtitle1'>Histórico construtivo:</Typography>
                </Grid>
                <Grid item xs={6} >
                  <Typography variant='subtitle1'>{dataProject?.historico_construtivo}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
              <Grid container item marginY={1}>
                <Grid item xs={6}>
                  <Typography variant='subtitle1'>Método construtivo:</Typography>
                </Grid>
                <Grid item xs={6} >
                  <Typography variant='subtitle1'>{dataProject?.metodo_construtivo}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
              <Grid container item marginY={1}>
                <Grid item xs={6}>
                  <Typography variant='subtitle1'>Quantidade de etapas/alteamentos previstos:</Typography>
                </Grid>
                <Grid item xs={6} >
                  <Typography variant='subtitle1'>{dataProject?.quantidade_etapas_previstas}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
              <Grid container item marginY={1}>
                <Grid item xs={6}>
                  <Typography variant='subtitle1'>Quantidade de etapas/alteamentos executados:</Typography>
                </Grid>
                <Grid item xs={6} >
                  <Typography variant='subtitle1'>{dataProject?.quantidade_etapas_executadas}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
            </Grid>
            <Box paddingY={1}>
              {dataSteps.map((item, index) => (
                <Box width='100%' paddingY={1} key={item.uuid}>
                  <Accordion key={item.uuid} variant='outlined'>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      Etapa construtiva {index + 1}
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container>
                        <Grid item container>
                          <Grid item xs={6}>
                            Elevação (m):
                          </Grid>
                          <Grid item xs={6}>
                            {item.elevacao ? item.elevacao : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Empresa projetista:
                          </Grid>
                          <Grid item xs={6}>
                            {item.empresa_projetista ? item.empresa_projetista : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            RT de projeto:
                          </Grid>
                          <Grid item xs={6}>
                            {item.rt_projeto ? item.rt_projeto : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Ano do projeto:
                          </Grid>
                          <Grid item xs={6}>
                            {item.ano_projeto ? item.ano_projeto : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Empresa construtora:
                          </Grid>
                          <Grid item xs={6}>
                            {item.empresa_construtora ? item.empresa_construtora : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            RT de obra:
                          </Grid>
                          <Grid item xs={6}>
                            {item.rt_obra ? item.rt_obra : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Empresa Fiscalizadora (ATO):
                          </Grid>
                          <Grid item xs={6}>
                            {item.empresa_fiscalizadora_ato ? item.empresa_fiscalizadora_ato : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            RT de Fiscalização/ ATO:
                          </Grid>
                          <Grid item xs={6}>
                            {item.rt_fiscalizacao_ato ? item.rt_fiscalizacao_ato : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Ano de construção:
                          </Grid>
                          <Grid item xs={6}>
                            {item.ano_construcao ? item.ano_construcao : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            As Built ou As Is:
                          </Grid>
                          <Grid item xs={6}>
                            {item.as_built_as_is ? item.as_built_as_is : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Empresa executora As Built ou As Is:
                          </Grid>
                          <Grid item xs={6}>
                            {item.empresa_executora_as_built_as_is ? item.empresa_executora_as_built_as_is : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                        <Grid item container>
                          <Grid item xs={6}>
                            Ano As Built ou As Is:
                          </Grid>
                          <Grid item xs={6}>
                            {item.ano_as_built_as_is ? item.ano_as_built_as_is : 'Não informado'}
                          </Grid>
                          <Grid item xs={12}>
                            <Divider />
                          </Grid>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Box>
              ))}
            </Box>
          </>
        ) : (<></>)}
      </Box>
    </Box>
  );
};